import React from 'react';

import {Group, Item} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

import {
    UPLOAD_FILE_MAX_SIZE_LIMIT_MB,
    UPLOAD_FILE_VALID_EXTENSIONS,
} from '../constants';

import {
    dropZoneViewServiceIcon,
} from './drop-zone-view.module.styl';


type Props = {
    addedFile: File | null,
};

const getUploadFileExtensionsLine = (): string => (
    UPLOAD_FILE_VALID_EXTENSIONS.map(item => item.slice(1).toUpperCase()).join(', ')
);

export const DropZoneView = ({addedFile}: Props) => {
    if (addedFile) {
        return (
            <Group direction="v" gap="s">
                <Icon className={dropZoneViewServiceIcon} type={Icons.CHECK_CIRCLE}/>
                <Item>Completed</Item>
            </Group>
        );
    }
    return (
        <Group direction="v" gap="xxs">
            <Icon className={dropZoneViewServiceIcon} type={Icons.UPLOAD}/>
            <span>Drag & drop a file to upload or <a>browse</a></span>
            <span className="disabled font-size font-size_footer">
                {
                    `Max. file size: ${UPLOAD_FILE_MAX_SIZE_LIMIT_MB} MB.
                    Accepted formats: ${getUploadFileExtensionsLine()}`
                }
            </span>
        </Group>
    );
};
